module.exports = __webpack_public_path__ + "img/vector.2c6bb0b4.svg";